import { useState } from "react";
import { slide as Menu } from "react-burger-menu";
import { BiTransfer, BiSupport, BiEditAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import ExitIcon from "./icons/ExitIcon";
import { apiService } from "../../service/service";
import AcceptModal from "../../../features/acceptModal/AcceptModal";
import { FiInfo, FiLogOut } from "react-icons/fi";
import { LuClipboardList } from "react-icons/lu";
import { CiLogout } from "react-icons/ci";

export default function SideBar(props) {
  const [user, setUser] = useState(null);
  const [acceptModal, setAcceptModal] = useState(false);
  const [pending, setPending] = useState(false);
  const [min_version_number] = useState(
    localStorage.getItem("min_version_number") || ""
  );
  function userExit() {
    setPending(true);
    apiService({ url: "api/user/logout" }).then((data) => {
      if (data) {
        localStorage.clear();
        window.location.href = "/";
      }
      setPending(false);
    });
  }
  function extraLink(url) {
    if (window.Android) {
      window.Android.openPaymentLink(url);
    } else {
      window.location.href = url;
    }
  }
  return (
    <Menu {...props}>
      <div
        className="small align-self-center z1 text-secondary border-2 position-absolute fs-7"
        style={{ bottom: "10px", left: "20px" }}
      >
        نسخه {min_version_number}
      </div>
      <div className="row mx-0 px-3 py-4 position-relative">
        <div className="row mx-0 p-0" style={{ zIndex: "1" }}>
          <div className="col-12 text-center mb-3 px-0 small align-self-center">
            <img
              alt="logo"
              width="50%"
              className=""
              src={require("../../assets/images/iran-app-logo.svg").default}
            />
          </div>
          <div className="col-12 text-center px-0 small align-self-center z1 text-white">
            <Link to={`set-profile`} className="text-white">
              {user?.name}
              {/* <BiEditAlt size={24} className="me-3" /> */}
              <p className="fs-7 mb-0 mt-2">{user?.phone}</p>
            </Link>
          </div>
        </div>
        <div
          className="row mx-0 p-0"
          style={{ zIndex: "1", marginTop: "135px" }}
        >
          <Link className="row mx-0 px-0 border-bottom" to={`/my-ticket-list`}>
            <div className="col-auto px-0 align-self-center">
              <BiTransfer className="text-secondary" size={23} />
            </div>
            <div className="col small align-self-center z1 text-secondary fw-bold py-3">
              لیست خرید های من
            </div>
          </Link>
          <div
            onClick={() => extraLink(`tel:02191302099`)}
            className="px-0 row mx-0 border-bottom"
          >
            <div className="col-auto px-0 align-self-center">
              <BiSupport size={24} className="text-muted" />
            </div>
            <div className="col small align-self-center z1 text-secondary fw-bold py-3 border-2">
              تماس با پشتیبانی
            </div>
          </div>
          <div
            onClick={() => extraLink("https://irana.app/about-us")}
            className="px-0 row mx-0 border-bottom"
          >
            <div className="col-auto px-0 align-self-center">
              <FiInfo size={24} className="text-muted" />
            </div>
            <div className="col small align-self-center z1 text-secondary fw-bold py-3 border-2">
              درباره ما
            </div>
          </div>
          <Link className="row mx-0 px-0 border-bottom" to={`/rules`}>
            <div className="col-auto px-0 align-self-center">
              <LuClipboardList size={24} className="text-muted" />
            </div>
            <div className="col small align-self-center z1 text-secondary fw-bold py-3 border-2">
              قوانین
            </div>
          </Link>
          <div className="row mx-0 px-0" onClick={() => setAcceptModal(true)}>
            <div className="col-auto px-0 align-self-center btn">
              <FiLogOut size={24} className="text-danger" />
            </div>
            <div className="col small align-self-center z1 text-danger fw-bold py-3 btn text-end">
              خروج از حساب کاربری
            </div>
          </div>
        </div>
        <AcceptModal
          text={"آیا از خروج خود مطمئن هستید؟"}
          acceptModal={acceptModal}
          acceptModalChange={(e) => setAcceptModal(e)}
          accept={() => userExit()}
          pending={pending}
        />
      </div>
    </Menu>
  );
}
